import React     from 'react'
import { Modal } from 'react-bootstrap'

export default ModalDialog = ({ show = true, size, title, closeButton, onHide, body, footer, children }) ->
  <Modal show={show} bsSize={size} onHide={onHide}>
    <Modal.Header closeButton={closeButton}><Modal.Title>{title}</Modal.Title></Modal.Header>
    <Modal.Body className="container-fluid scrollable">{body or children}</Modal.Body>
    {<Modal.Footer>{footer}</Modal.Footer> if footer}
  </Modal>
